import {
  SVGInfo,
  InputGroup,
  InputRow,
  ModelDateDMY,
  ModelInput,
  Input,
  formatNumber,
} from '@equifinance/shared';
import styled, { css } from 'styled-components';
import { useMemo } from 'react';
import { DateFormatStringEnum, formatDateTime, isValidDate } from '@equifinance/shared/utils';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';
import { useChecklistContext } from '../../../../contexts';

const DueDateStyle = css`
  width: 50px;
`;

const DueDateContainerCssStyle = css`
  flex: none;
`;

const InputRowItem = styled.div`
  flex: 1 1 0%;
`;

const FirstPaymentValue = styled.div`${({ theme }) => `
  font-size: ${theme.fontSize[2]};
  line-height: ${theme.fontSize[6]};
  height: ${theme.fontSize[9]};
  display: flex;
  align-items: center;
`}`;

export default function PostOfferDatesSection() {
  const { checklist } = useChecklistContext();
  const { postOffer } = checklist ?? {};

  const firstPaymentDate = useMemo(() => {
    if (!isValidDate(postOffer?.dates.collectionDate, DateFormatStringEnum.ISO8601)) {
      return '-';
    }
    return formatDateTime(postOffer?.dates.collectionDate, DateFormatStringEnum.DDMMYYYY);
  }, [postOffer?.dates.collectionDate]);

  const firstPaymentAmount = useMemo(() => {
    if (postOffer?.dates.firstPaymentAmount == null) {
      return '-';
    }
    return `£ ${formatNumber(postOffer.dates.firstPaymentAmount, 2)}`;
  }, [postOffer?.dates.firstPaymentAmount]);

  return (
    <PaddedGenericSection
      subSection={ChecklistSection.POST_DATES}
      level={1}
    >
      <SVGInfo>Please ensure this data is accurately completed. This is sent to Phoebus and can’t easily be changed post transition.</SVGInfo>
      <InputGroup>
        <InputRow>
          <InputRowItem>
            <ModelDateDMY
              field="postOffer.dates.completionDate"
              label="Completion date"
              disabled={
                postOffer?.checklistIndicatorType === 'Locked'
                || postOffer?.submitted
              }
              showDay
              required
            />
          </InputRowItem>
          <InputRowItem>
            <ModelInput
              label="Due date"
              field="postOffer.dates.dueDate.specificDayOfMonth"
              placeholder="DD"
              required
              styles={DueDateStyle.toString()}
              inputWrapperCss={DueDateContainerCssStyle.toString()}
              disabled={
                postOffer?.checklistIndicatorType === 'Locked'
                || postOffer?.submitted
              }
              mutateValue={(v) => {
                const input = v?.toString()?.replace(/\D/g, '');
                if (input.length === 2) return input;
                if (input.length > 2) return input.slice(1, 3);
                if (input.length === 1 && input !== '0') return `0${input}`;
                return input;
              }}
            />
          </InputRowItem>
        </InputRow>
        <InputRow>
          <InputRowItem>
            <Input
              id={postOffer?.dates.id || ''}
              label="First Payment date"
              required
            >
              <FirstPaymentValue>{firstPaymentDate}</FirstPaymentValue>
            </Input>
          </InputRowItem>
          <InputRowItem>
            <Input
              id="firstPaymentAmount"
              label="First Payment amount"
              required
            >
              <FirstPaymentValue>{firstPaymentAmount}</FirstPaymentValue>
            </Input>
          </InputRowItem>
        </InputRow>
      </InputGroup>
    </PaddedGenericSection>
  );
}
